export type PhoneCountry = {
  code: string;
  name: string;
  dialCode: string;
};

export const phoneCountries: PhoneCountry[] = [
  { code: "AU", name: "Australia", dialCode: "61" },
  { code: "AT", name: "Austria", dialCode: "43" },
  { code: "BE", name: "Belgium", dialCode: "32" },
  { code: "BH", name: "Bahrain", dialCode: "973" },
  { code: "BD", name: "Bangladesh", dialCode: "880" },
  { code: "BR", name: "Brazil", dialCode: "55" },
  { code: "BG", name: "Bulgaria", dialCode: "359" },
  { code: "CA", name: "Canada", dialCode: "1" },
  { code: "CL", name: "Chile", dialCode: "56" },
  { code: "CN", name: "China", dialCode: "86" },
  { code: "CO", name: "Colombia", dialCode: "57" },
  { code: "CR", name: "Costa Rica", dialCode: "506" },
  { code: "CY", name: "Cyprus", dialCode: "357" },
  { code: "CZ", name: "Czech Republic", dialCode: "420" },
  { code: "DK", name: "Denmark", dialCode: "45" },
  { code: "DO", name: "Dominican Republic", dialCode: "1" },
  { code: "EG", name: "Egypt", dialCode: "20" },
  { code: "EE", name: "Estonia", dialCode: "372" },
  { code: "FI", name: "Finland", dialCode: "358" },
  { code: "FR", name: "France", dialCode: "33" },
  { code: "DE", name: "Germany", dialCode: "49" },
  { code: "GR", name: "Greece", dialCode: "30" },
  { code: "GT", name: "Guatemala", dialCode: "502" },
  { code: "HK", name: "Hong Kong", dialCode: "852" },
  { code: "HU", name: "Hungary", dialCode: "36" },
  { code: "IN", name: "India", dialCode: "91" },
  { code: "IE", name: "Ireland", dialCode: "353" },
  { code: "IL", name: "Israel", dialCode: "972" },
  { code: "IT", name: "Italy", dialCode: "39" },
  { code: "JP", name: "Japan", dialCode: "81" },
  { code: "KE", name: "Kenya", dialCode: "254" },
  { code: "KR", name: "South Korea", dialCode: "82" },
  { code: "KW", name: "Kuwait", dialCode: "965" },
  { code: "LV", name: "Latvia", dialCode: "371" },
  { code: "LB", name: "Lebanon", dialCode: "961" },
  { code: "LT", name: "Lithuania", dialCode: "370" },
  { code: "LU", name: "Luxembourg", dialCode: "352" },
  { code: "MY", name: "Malaysia", dialCode: "60" },
  { code: "MT", name: "Malta", dialCode: "356" },
  { code: "MX", name: "Mexico", dialCode: "52" },
  { code: "MD", name: "Moldova", dialCode: "373" },
  { code: "ME", name: "Montenegro", dialCode: "382" },
  { code: "NL", name: "Netherlands", dialCode: "31" },
  { code: "NZ", name: "New Zealand", dialCode: "64" },
  { code: "NG", name: "Nigeria", dialCode: "234" },
  { code: "NO", name: "Norway", dialCode: "47" },
  { code: "OM", name: "Oman", dialCode: "968" },
  { code: "PK", name: "Pakistan", dialCode: "92" },
  { code: "PE", name: "Peru", dialCode: "51" },
  { code: "PH", name: "Philippines", dialCode: "63" },
  { code: "PL", name: "Poland", dialCode: "48" },
  { code: "PT", name: "Portugal", dialCode: "351" },
  { code: "QA", name: "Qatar", dialCode: "974" },
  { code: "RO", name: "Romania", dialCode: "40" },
  { code: "SA", name: "Saudi Arabia", dialCode: "966" },
  { code: "RS", name: "Serbia", dialCode: "381" },
  { code: "SG", name: "Singapore", dialCode: "65" },
  { code: "SK", name: "Slovakia", dialCode: "421" },
  { code: "SI", name: "Slovenia", dialCode: "386" },
  { code: "ZA", name: "South Africa", dialCode: "27" },
  { code: "ES", name: "Spain", dialCode: "34" },
  { code: "SE", name: "Sweden", dialCode: "46" },
  { code: "CH", name: "Switzerland", dialCode: "41" },
  { code: "TW", name: "Taiwan", dialCode: "886" },
  { code: "TH", name: "Thailand", dialCode: "66" },
  { code: "TR", name: "Turkey", dialCode: "90" },
  { code: "UA", name: "Ukraine", dialCode: "380" },
  { code: "AE", name: "United Arab Emirates", dialCode: "971" },
  { code: "GB", name: "United Kingdom", dialCode: "44" },
  { code: "US", name: "United States", dialCode: "1" },
  { code: "UY", name: "Uruguay", dialCode: "598" },
  { code: "VN", name: "Vietnam", dialCode: "84" },
];

export const defaultPhoneCountryCode = "GB";

export function getPhoneCountry(code: string | null | undefined): PhoneCountry {
  return phoneCountries.find((country) => country.code === code?.toUpperCase()) ?? phoneCountries.find((country) => country.code === defaultPhoneCountryCode)!;
}

export function normalizeNationalNumber(input: string): string {
  return input.replace(/\D/g, "").replace(/^0+/, "");
}

export function normalizePhoneValue(countryCode: string, nationalNumber: string): string {
  const country = getPhoneCountry(countryCode);
  const cleaned = normalizeNationalNumber(nationalNumber);
  return cleaned ? `+${country.dialCode}${cleaned}` : "";
}

export function parseInternationalPaste(text: string): { countryCode?: string; nationalNumber: string } {
  const cleaned = text.trim().replace(/[^\d+]/g, "");
  if (!cleaned) return { nationalNumber: "" };
  const digits = cleaned.startsWith("+") ? cleaned.slice(1) : cleaned.startsWith("00") ? cleaned.slice(2) : cleaned;
  const match = [...phoneCountries].sort((a, b) => b.dialCode.length - a.dialCode.length).find((country) => digits.startsWith(country.dialCode));
  if (!match) return { nationalNumber: normalizeNationalNumber(digits) };
  return { countryCode: match.code, nationalNumber: normalizeNationalNumber(digits.slice(match.dialCode.length)) };
}
